import cabecalho from '@/components/global/Cabecalho/Cabecalho.vue'
import menuLateral from '@/components/global/MenuLateral/MenuLateral.vue'
import spinnerProcessando from '@/components/layout/spinnerProcessamento/SpinnerProcessamento.vue'
import { BSpinner, BModal } from 'bootstrap-vue'
import util from '@/util'
import mensagens from '@/util/mensagens'
import Plano from '@/views/contratos/Plano.vue'
import DuvidasFrequentes from '@/views/produtos/DuvidasFrequentes.vue'
import { mapActions, mapGetters } from 'vuex'
import constants from '@/util/constants'
import Aviso from '../Aviso.vue'

export default {
  name: 'contratos',
  components: {
    cabecalho,
    menuLateral,
    spinnerProcessando,
    'b-spinner': BSpinner,
    'b-modal': BModal,
    Plano,
    DuvidasFrequentes,
    Aviso
  },
  computed: {
    ...mapGetters('carrinho', ['temProdutoMirtContratado', 'obterTotalItensCarrinho', 'itensCarrinho'])
  },
  data: () => {
    return {
      planos: [],
      pedidoCancelamento: false,
      podeAlterarPlano: false,
      planoContratado: null,
      duplaChecagem: false,
      confirmou: false,
      dadosPlano: {
        id: null,
        nome: null,
        produto: {
          id: null,
          nome: null
        }
      },
      mensagemNotificacao: '',
      flagsDeControle: {
        carregandoDados: {
          status: false,
          mensagem: ''
        }
      }
    }
  },
  mounted () {
    this.obterPlanos()

    this.pedidoCancelamento = localStorage.getItem('pedido_cancelamento') === 'true' ?? false
    this.podeAlterarPlano = localStorage.getItem('pode_alterar_plano') === 'true' ?? false

    if (this.obterTotalItensCarrinho > 0 && this.itensCarrinho.filter(r => r.produto.id !== constants.idProdutoMirt).length > 0) {
      this.duplaChecagem = true
      this.$refs.aviso_modal.openModal()
    }
  },
  methods: {
    ...mapActions('carrinho', [
      'ActionLimparDadosCarrinho', 'ActionAdicionarItemCarrinho'
    ]),
    async obterPlanos () {
      this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
      try {
        const resposta = await this.axios.get(`/manager/conta/contrato/produto/planos`)
        this.planos = [...resposta.data.retorno.dados]

        this.planoContratado = this.planos.filter(plano => plano.contratado === true)[0]
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, '')
    },
    async efetuarContratacao (dadosFormulario) {
      const formulario = util.mapearObjetos(dadosFormulario, {})
      const parametrosRequisicao = {
        'plano_id': this.dadosPlano.id,
        'senha_usuario': formulario.senha_usuario,
        'email_usuario': formulario.email_usuario,
        'aceite_contrato': formulario.aceite_contrato,
        'quantidade': formulario.quantidade
      }
      const resposta = await this.axios.put('/manager/conta/contrato/produto/trocar-plano', parametrosRequisicao)
      return resposta
    },
    obterMensagemRestituicao (planoSelecionado) {
      const planoContratado = this.planos.find(plano => plano.contratado === true)

      if (planoSelecionado?.valor < planoContratado?.valor) {
        const diaVencimento = 18
        return `A efetivação da troca ocorrerá no dia ${diaVencimento} (próximo vencimento), pois não haverá restituição do valor`
      }
      return ''
    },
    showModalContratarProduto (plano) {
      const planoFoiSelecionado = !util.valorEhNulo(plano.id)
      if (planoFoiSelecionado) {
        this.mensagemNotificacao = this.obterMensagemRestituicao(plano)
        this.enviarDadosParaModal({ id: plano.id, nome: plano.nome, produto: plano.produto })
        this.$bvModal.show('modalContratarProduto')
      }
    },
    enviarDadosParaModal ({ id, nome, produto }) {
      this.dadosPlano = {
        id,
        nome,
        produto
      }
    },
    formatarValorMonetario (valor) {
      return util.formatarValorMonetarioComCifrao(valor)
    },
    enviarParaCarrinho (plano) {
      if (this.temProdutoMirtContratado) {
        this.$router.push({ name: 'carrinho' }).then(() => {
          util.criarAlertaToastDeSucesso(this, 'Aviso', 'Este produto já está no carrinho')
        })
        return
      }

      this.ActionLimparDadosCarrinho()
      const item = {
        produto: {
          nome: plano.produto.nome,
          id: plano.produto.id,
          icone: plano.produto.icone,
          quantidade: 1,
          plano: {
            id: plano.id,
            valor: plano.valor,
            descricao: plano.descricao,
            item_planos: plano.item_planos
          }
        }
      }
      this.ActionAdicionarItemCarrinho(item)
      this.$router.push({ name: 'carrinho' })
    },
    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    }

  }
}
